import { clientConfigFn } from "../../clientConfig";

export function getCurrencySymbol() {
    return new Intl.NumberFormat(clientConfigFn().currencyLocale, { style: 'currency', currency: clientConfigFn().currencyFormat }).formatToParts(undefined)[0].value;
}
